export default "static/src/images/Limes-video-cover.png";